import React from "react"
import TextInput from "./TextInput"

function EmailInput({
  value,
  onChange,
  placeHolder,
  name,
  label,
  error,
  success
}) {
  return (
    <TextInput
      inputType="email"
      placeHolder={placeHolder}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      success={success}
    />
  )
}

export default EmailInput
